export const BRAND = {
  name: "HEARD",
  legal: "HEARD Community",
  domain: "ourheardcommunity.com",
  email: "support@ourheardcommunity.com",
};
